// frontend/src/routes/AppRoutes.js
// Purpose: Define the application's routing structure
// Desired outcome: Create a routing system that redirects to the upload page by default and only shows Upload and Analysis pages

// Import dependencies
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import pages
import UploadPage from '../pages/UploadPage/UploadPage';
import AnalysisPage from '../pages/AnalysisPage/AnalysisPage';
import ChatPage from '../pages/ChatPage/ChatPage';

// NotFound page
const NotFoundPage = () => <div>404 - Page Not Found</div>;

// Auth protection component
const ProtectedRoute = ({ children }) => {
  // This is a simplified version. In a real app, you'd check for auth token
  // existence and validity, and redirect if not authenticated
  const isAuthenticated = true; // Replace with actual auth check
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Define the application routes
const AppRoutes = () => {
  return (
    <Routes>
      {/* Redirect root to upload page */}
      <Route path="/" element={<Navigate to="/upload" replace />} />
      
      {/* Protected routes */}
      <Route 
        path="/upload" 
        element={
          <ProtectedRoute>
            <UploadPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/analysis" 
        element={
          <ProtectedRoute>
            <AnalysisPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/chat" 
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        } 
      />
      
      {/* Catch-all route for 404s */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;